import axios from './index';

class OrderApi {
  static List = (data) => {
    let query = '?';
    if (data.orderType) {
      query += `order_type=${data.orderType}&`;
    }
    if (data.status) {
      query += `status=${data.status}&`;
    }
    if (data.orderId) {
      query = `${data.orderId}`;
    }
    if (data.customerId) {
      query += `user_id=${data.customerId}&`;
    }
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.selectedStatusTypeValue) {
      query += `status_type=${data.selectedStatusTypeValue}&`;
    }
    if (data.selectedOrderTypeValue) {
      query += `order_type=${data.selectedOrderTypeValue}&`;
    }
    if (data.filterStartDate) {
      query += `start_date=${data.filterStartDate}&`;
    }
    if (data.filterEndDate) {
      query += `end_date=${data.filterEndDate}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    return axios.get(`${base}/${query}`);
  };

  static Verify = (data) => {
    let query = `verify-transaction/${data?.transactionId}`;
    return axios.get(`${base}/${query}`);
  };

  static CheckStatus = (data) => {
    let query = `check-transaction-status/${data?.transactionId}`;
    return axios.get(`${base}/${query}`);
  };

  static StartTransactionVerify = (data) => {
    let query = `start-transaction/${data?.orderId}`;
    return axios.get(`${base}/${query}`);
  };

  static StartTransactionJustpay = (data) => {
    let query = `starttransaction-justpay/${data?.orderId}`;
    return axios.get(`customer/order/${query}`);
  };

  static GetInvoice = (id) => {
    return axios.get(`${base}/invoice/${id}`);
  };

  static SendInvoice = (data) => {
    let request = {};
    if (data.email) request.email = data.email;
    return axios.put(`${base}/sendinvoice/${data.order_id}`, request);
  }
}

let base = 'customer/admin/order';

export default OrderApi;
